namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyForm {
        Status: Serenity.RadioButtonEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        TimeFg: Serenity.RadioButtonEditor;
        StartTime: Common.EditTimeEditor;
        EndTime: Common.EditTimeEditor;
        PosFg: Serenity.RadioButtonEditor;
        PosId: Serenity.LookupEditor;
        SurveyCode: Serenity.StringEditor;
        Question: Serenity.StringEditor;
        DtList: PsCustomerSurveyDtEditor;
        ActiveBy: Serenity.StringEditor;
        Activedate: Serenity.DateEditor;
    }

    export class PsCustomerSurveyForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCustomerSurvey';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCustomerSurveyForm.init)  {
                PsCustomerSurveyForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.DateEditor;
                var w2 = Common.EditTimeEditor;
                var w3 = s.LookupEditor;
                var w4 = s.StringEditor;
                var w5 = PsCustomerSurveyDtEditor;

                Q.initFormType(PsCustomerSurveyForm, [
                    'Status', w0,
                    'StartDate', w1,
                    'EndDate', w1,
                    'TimeFg', w0,
                    'StartTime', w2,
                    'EndTime', w2,
                    'PosFg', w0,
                    'PosId', w3,
                    'SurveyCode', w4,
                    'Question', w4,
                    'DtList', w5,
                    'ActiveBy', w4,
                    'Activedate', w1
                ]);
            }
        }
    }
}
